import type { AssistantModelMessage, ToolModelMessage, UIMessage } from 'ai';

type ResponseMessageWithoutId = ToolModelMessage | AssistantModelMessage;
type ResponseMessage = ResponseMessageWithoutId & { id: string };

export function getMostRecentUserMessage(messages: Array<UIMessage>) {
  const userMessages = messages.filter((message) => message.role === 'user');
  return userMessages.at(-1);
}

export function getTrailingMessageId({ messages }: { messages: Array<ResponseMessage> }): string | null {
  const trailingMessage = messages.at(-1);

  if (!trailingMessage) return null;

  return trailingMessage.id;
}

export function sanitizeText(text: string) {
  return text.replace('<has_function_call>', '');
}

export function getChatPlaceholder({
  accountName,
  programType,
  skillsEnabled,
}: {
  accountName?: string;
  programType?: string;
  skillsEnabled?: boolean;
}): string {
  const skillsPrefix = skillsEnabled ? 'Type / for skills or ' : '';

  if (!accountName || !programType) {
    return `${skillsPrefix}${skillsEnabled ? 'a' : 'A'}sk a question...`;
  }

  if (programType === 'PROPERTY_AND_CASUALTY') {
    return `${skillsPrefix}${skillsEnabled ? 'a' : 'A'}sk about ${accountName}'s policies, coverage, renewals...`;
  }

  if (programType === 'EMPLOYEE_BENEFITS') {
    return `${skillsPrefix}${skillsEnabled ? 'a' : 'A'}sk about ${accountName}'s plans, rates, contributions...`;
  }

  return `${skillsPrefix}${skillsEnabled ? 'a' : 'A'}sk a question...`;
}

/**
 * Check if a chat is new (no UUID or no messages)
 */
export function isNewChat(chatUuid?: string): boolean {
  return !chatUuid;
}
